import { useOnPathChange } from 'hooks/useOnPathChange';
import React from 'react';
import { useWizardInfo } from '../providers/WizardInfoProvider';

type WizardPathToStepControllerProps = {
  routeStepMap: Record<string, number>;
};

const WizardPathToStepController = ({ routeStepMap }: WizardPathToStepControllerProps) => {
  const { setCurrentStep } = useWizardInfo();

  useOnPathChange((path) => {
    setCurrentStep(routeStepMap[path] ?? 0);
  });

  return null;
};

export default React.memo(WizardPathToStepController);
